export default __webpack_public_path__ + "static/cybersource-3c84f3e922468a1935911ea6de479ab2.jpeg";